import { Directive, DoCheck, ElementRef, HostBinding } from '@angular/core';

// Suppresses Angular Material MatInput's built-in
// `[attr.aria-required]="required"` host binding so that
// <input matInput required> / <textarea matInput required> no longer
// emit a redundant aria-required="true" attribute in the rendered DOM.
//
// Why: WCAG audit (4.1.2 Name, Role, Value) flagged the duplication —
// the native `required` attribute already communicates the required
// state to browsers and assistive tech. See
// node_modules/@angular/material/fesm2020/input.mjs for the upstream
// binding that this directive overrides.
//
// The HostBinding handles the common case; ngDoCheck is a defensive
// fallback for the directive-ordering race with MatInput's own host
// binding on the same attribute.
@Directive({
  selector: 'input[matInput][required], textarea[matInput][required]'
})
export class NoMatInputAriaRequiredDirective implements DoCheck {
  @HostBinding('attr.aria-required') readonly ariaRequired: null = null;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngDoCheck(): void {
    const node = this.el.nativeElement;
    if (node.hasAttribute('aria-required')) {
      node.removeAttribute('aria-required');
    }
  }
}
